import { LINKS } from "./links";

export const FINANCE = {
  LOCAL_ANNOUNCEMENTS: {
    title: "Bandi sul territorio",
    button: {
      link: LINKS.LOCAL_ANNOUNCEMENTS,
    },
  },
  CLICK_DAY: {
    title: "Click Day",
    button: {
      link: LINKS.CLICK_DAY,
    },
  },
};
